/**
 * Parses a single-column CSV string: one value per row.
 * Supports quoted fields (RFC 4180-style) and uses the first column when commas appear unquoted.
 */
export const parseSingleColumnCsvValues = (content: string): string[] => {
	const lines = content.split(/\r?\n/);
	const result: string[] = [];

	for (const line of lines) {
		const cell = parseFirstCsvField(line);
		const trimmed = cell.trim();
		if (trimmed === '') {
			continue;
		}
		result.push(trimmed);
	}

	return result;
};

const parseFirstCsvField = (line: string): string => {
	const trimmed = line.trim();
	if (trimmed === '') {
		return '';
	}

	if (trimmed.startsWith('"')) {
		let out = '';
		let i = 1;
		while (i < trimmed.length) {
			const ch = trimmed[i];
			if (ch === '"') {
				if (trimmed[i + 1] === '"') {
					out += '"';
					i += 2;
					continue;
				}
				return out;
			}
			out += ch;
			i += 1;
		}
		return out;
	}

	const commaIndex = trimmed.indexOf(',');
	return commaIndex === -1 ? trimmed : trimmed.slice(0, commaIndex).trim();
};
